export default "__VITE_ASSET__BdXHUeXn__"